<template>
    <transition name="fade">
        <div :class="[this.error ? errorClass : '', alertClass]" v-show="show" @show-alert="showAlert(alert)" v-text="message"></div>
    </transition>
</template>

<script>
    export default {
        data() {
            return {
                show: false,
                message: 'Hello World',
                error: false,
                errorClass: 'Alert__Error',
                alertClass: 'Alert'
            };
        },

        created() {
            Bus.$on('show-success-alert', this.showSuccessAlert);
            Bus.$on('show-error-alert', this.showErrorAlert);
        },

        methods: {
            showSuccessAlert(message) {
                this.message = message;
                this.show = true;
                this.error = false;
                setTimeout(() => this.show = false, 5000);
            },

            showErrorAlert(message) {
                this.message = message;
                this.show = true;
                this.error = true;
                setTimeout(() => this.show = false, 8000);
            }
        }
    }
</script>

<style scoped>
    .fade-enter-active, .fade-leave-active {
        transition: all .3s ease;
    }

    .fade-enter, .fade-leave-active {
        opacity: 0;
    }

</style>



// WEBPACK FOOTER //
// resources/assets/js/components/globals/Alert.vue